import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SurveyCategoriesDataGrid } from "src/components/views/erp/surveys/management/categories/SurveyCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/surveys/surveyCategories")({
	staticData: { title: i18n.t("survey_categories"), legacyViewKey: "surveyCategoriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SurveyCategoriesDataGrid />;
}
